<template>
    <v-container class="pa-0" :class="data.class">
        <v-row no-gutters>
            <v-col cols="10"  data-aos="fade-right" class="position-relative z-index-10" ref="top-title">
                <v-container class="py-0 "  >
                    <h3 
                        class="text-h4 text-md-h3 px-3 px-lg-5" 
                        v-html="data.title['pre-text']">
                    </h3>
                    <h3 class="text-h4 text-md-h3 px-3 px-lg-5" :class="'text-'+data.title['inner-color']" ref="inner-title" v-html="data.title['inner-text']"></h3>
                </v-container>
            </v-col>
            <v-col cols="12">
                <v-img
                    :lazy-src="data.images.desktop.sizes.thumbnail"
                    lazy
                    :gradient="(data.gradient) ? gradientColor[data.gradient] : null"
                    :src="data.images.desktop.sizes.full"
                    cover
                    max-height="55vh"
                    :alt="data.images.desktop.title+' - '+data.images.desktop.description"
                    class="mx-auto z-index-9"
                ></v-img>
            </v-col>
            <v-col cols="9" md="5" offset="3" offset-md="7"  data-aos="fade-left" class="position-relative z-index-10" ref="bottom-text">
                <v-container class="py-0 px-2">
                    <p class="text-h5 text-md-h4"  :class="'text-'+data.title['inner-color']" ref="inner-text" v-html="data.text['inner-text']"></p>
                    <p class="text-h5 text-md-h4"  v-html="data.text['post-text']"></p>
                </v-container>
                <v-container class="py-3">
                    <div cols="12" data-aos-delay="50" v-if="data.has_button">
                        <v-hover>
                            <template v-slot:default="{ isHovering, props }">
                                <v-btn 
                                    :to="(data.button.route)  ? data.button.route :data.button.link" 
                                    class="btn-primelinks" 
                                    v-bind="props"
                                    variant="text" 
                                    :class="isHovering ? '' : 'ps-0'" 
                                    :color="data.button.color">
                                    <span class="text-underline">{{data.button.text}}</span>
                                    <v-icon class="ms-3">{{data.button.icon}}</v-icon>
                                </v-btn>
                            </template>
                        </v-hover>
                    </div>
                </v-container>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default{
    name: 'TitleImageTextLinkComponent',
    props:{
        data:{
            required: true,
            type: Object,
        }
    },
    data: () => ({
        gradientColor:{
            black: "to bottom, rgba(0,0,0,1), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0), rgba(0,0,0,0),  rgba(0,0,0,1)",
            white: "to bottom, rgba(255,255,255,1), rgba(255,255,255,0), rgba(255,255,255,0), rgba(255,255,255,0), rgba(255,255,255,0), rgba(255,255,255,1)",
            primary: "to bottom, rgba(179,148,127,1), rgba(179,148,127,0), rgba(179,148,127,0),rgba(179,148,127,0),rgba(179,148,127,0),  rgba(179,148,127,1)",
            brown: "to bottom, rgba(72, 59, 51,1), rgba(72, 59, 51,0), rgba(72, 59, 51,0),rgba(72, 59, 51,0),rgba(72, 59, 51,0), rgba(72, 59, 51,1)"
        }
    }),
    watch:{
        '$vuetify.display.name': function () {
            this.calcHeight()
        },
    },
    mounted(){
        this.calcHeight()
    },
    updated(){
        this.calcHeight()
    },
    methods:{
        calcHeight(){
            let innerTitle = this.$refs['inner-title']
            let innerText = this.$refs['inner-text']

            let topTitle = this.$refs['top-title']
            let bottomText = this.$refs['bottom-text']

            let innerTitleHeight = innerTitle.offsetHeight
            let innerTextHeight = innerText.offsetHeight

            topTitle.$el.style.top = innerTitleHeight+'px'
            bottomText.$el.style.top = -innerTextHeight+'px'

        }
    }
}
</script>

<style scoped>
.text-shadow{
    text-shadow: 2px 1px 8px rgba(0,0,0,0.5);
}
</style>